import { render, staticRenderFns } from "./UpdateAgentBrand.vue?vue&type=template&id=91bafe7c&scoped=true"
import script from "./UpdateAgentBrand.vue?vue&type=script&lang=js"
export * from "./UpdateAgentBrand.vue?vue&type=script&lang=js"
import style0 from "./UpdateAgentBrand.vue?vue&type=style&index=0&id=91bafe7c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91bafe7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91bafe7c')) {
      api.createRecord('91bafe7c', component.options)
    } else {
      api.reload('91bafe7c', component.options)
    }
    module.hot.accept("./UpdateAgentBrand.vue?vue&type=template&id=91bafe7c&scoped=true", function () {
      api.rerender('91bafe7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/brandname/UpdateAgentBrand.vue"
export default component.exports